import { ElementRef, Injectable } from '@angular/core';

interface NamedElementRef {
  name: string;
  element: ElementRef;
}

@Injectable()
export class ElementClassService {
  private elements: NamedElementRef[] = [];

  registerElement(name: string, element: ElementRef) {
    this.unregisterElement(name); // to enforce only one element register under one name
    this.elements.push({ name, element });
  }

  unregisterElement(name: string) {
    this.elements = this.elements.filter(el => el.name !== name);
  }

  addClassTo(name, className) {
    const el = this.findElement(name);

    if (el) {
      el.nativeElement.classList.add(className);
    }
  }

  removeClassFrom(name, className) {
    const el = this.findElement(name);

    if (el) {
      el.nativeElement.classList.remove(className);
    }
  }

  private findElement(name): ElementRef | null {
    const found = this.elements.find(el => el.name === name);

    if (found) {
      return found.element;
    }

    return null;
  }
}
